import React from "react";
import { Box, styled, Typography } from "@mui/material";
import moment from "moment/moment";

const Container = styled(Box)(({ theme }) => ({
	background: "rgba(255,255,255,0.1)",
	borderRadius: 20,
}));

const ContentContainer = styled(Box)(({ theme }) => ({
	background: "rgba(255,255,255,0.1)",
	borderBottomLeftRadius: 20,
	borderBottomRightRadius: 20,
	padding: "20px 30px",
}));

const UserContainer = styled(Box)(({ theme }) => ({
	background: "#A5D0C9",
	height: 45,
	width: 45,
	borderRadius: "50%",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
}));

const CommunityCard = ({ firstName, lastName, date, question }) => {
	const formatedDate = React.useMemo(() => {
		return moment(date * 1000).format("DD MMMM YYYY");
	}, [date]);

	return (
		<Container>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 20px" }}>
				<Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
					<UserContainer>
						<Typography color={"#182B43"} fontFamily={"Yeseva One"} fontSize={20}>
							{firstName[0]}
						</Typography>
					</UserContainer>
					<Typography
						color={"#FFFFFF"}
						fontFamily={"Branding"}
						fontWeight={600}
						fontSize={16}
					>{`${firstName} ${lastName[0]}.`}</Typography>
				</Box>
				<Typography
					color={"rgba(255,255,255,0.5)"}
					fontFamily={"Branding"}
					fontWeight={600}
					fontSize={16}
					textAlign={"right"}
				>
					Le {formatedDate}
				</Typography>
			</Box>
			<ContentContainer>
				<Typography
					color={"#ffffff"}
					fontFamily={"Branding"}
					fontWeight={600}
					fontSize={16}
					dangerouslySetInnerHTML={{ __html: question }}
				/>
			</ContentContainer>
		</Container>
	);
};

export default CommunityCard;
